/** Wholesaler Review queue tab (v1 wholesalerReviewPanel). Deals wholesalers
 * submitted, pending your call: Approve adds a Pre-Check lead to Properties,
 * Reject drops it. Both mutate the WHOLESALER_QUEUE blob; approve also creates a
 * real lead, so it's gated with the same switch as the rest of the console. */
import { useState } from "react";
import type { QueueItem } from "./wholesalerQueue";

export function WholesalerReviewTab({ queue, canEdit, onApprove, onReject }: {
  queue: QueueItem[];
  canEdit: boolean;
  onApprove: (item: QueueItem) => void;
  onReject: (item: QueueItem) => void;
}) {
  const [busy, setBusy] = useState<string | null>(null);
  const act = (item: QueueItem, fn: (i: QueueItem) => void) => {
    if (!canEdit) return;
    setBusy(item.id);
    try { fn(item); } finally { setBusy(null); }
  };

  return (
    <div className="leads exppage">
      <div className="exphead">
        <h1>Wholesaler Review</h1>
        <div className="expacts"><span className="expcat">{queue.length} pending</span></div>
      </div>
      <div className="expqbo">
        Deals submitted by wholesalers. Approve to add to Properties as a new lead (Pre-Check), or reject.
        {canEdit ? "" : " Review actions are view-only on this device."}
      </div>

      {queue.length === 0 ? (
        <div className="expempty">✓ Queue empty — all reviewed.</div>
      ) : (
        <div className="wqlist">
          {queue.map((q) => (
            <div key={q.id} className="wqcard">
              <div className="wqicon">🏠</div>
              <div className="wqmain">
                <div className="wqaddr">{q.a}</div>
                <div className="wqmeta">
                  {[q.src && q.src, q.price && `Ask ${q.price}`, q.arv && `ARV ${q.arv}`, q.seller && `Seller ${q.seller}`].filter(Boolean).join(" · ")}
                </div>
              </div>
              {canEdit ? (
                <div className="wqacts">
                  <button className="btn slim primary" disabled={busy === q.id} onClick={() => act(q, onApprove)}>✓ Approve</button>
                  <button className="btn slim" disabled={busy === q.id} onClick={() => act(q, onReject)}>Reject</button>
                </div>
              ) : null}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
